import React, { useMemo, useCallback, useState } from 'react';
import { Spin, Icon, Modal } from 'antd';
import { Table, Button } from '../../../components/ui';
import { useGetSIBDomains } from 'query/admin';
import SIBDomainForm from './SIBDomainForm';
import { useDeleteSIBDomain } from 'mutation/admin';

export default function SIBDomains() {
  const { data: sibDomains, isLoading } = useGetSIBDomains();
  const [visible, setVisible] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState(null);
  
  const { mutate: deleteDomain } = useDeleteSIBDomain({});  

  const handleSelectDomain = useCallback(
    domain => () => {
      setSelectedDomain(domain);
      setVisible(true);
    },
    [],
  );

  const handleDeleteDomain = useCallback(
    id => () => {
      Modal.confirm({
        title: 'Confirmation',
        content: `Are you sure you want to continue?`,
        okText: 'Yes',
        okType: 'primary',
        onOk: () => deleteDomain(id),
        cancelText: 'No',
      });
    },
    [],
  );

  const columns = useMemo(() => {
    return [
      {
        title: 'Domain',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Dedicated IP',
        dataIndex: 'ip',
        key: 'ip',
      },
      {
        title: 'Is Active',
        align: 'center',
        dataIndex: 'isActive',
        key: 'isActive',
        render: isActive => (
          <div>
            {isActive ? (
              <Icon type="check" />
            ) : (
              <Icon theme="filled" type="close-circle" />
            )}
          </div>
        ),
      },
      {
        title: 'Actions',
        key: 'actions',
        align: 'center',
        render: (row) => {
          return (
            <div
              className="flex items-center space-x-2"
              style={{ justifyContent: 'center' }}
            >
              <Button onClick={handleSelectDomain(row)}>Update</Button>
              <Button onClick={handleDeleteDomain(row.id)}>Delete</Button>
            </div>
          );
        },
      },
    ];
  }, [handleSelectDomain]);

  return (
    <Spin spinning={isLoading}>
      <Button style={{ marginBottom: 10 }} onClick={() => setVisible(true)}>
        Add SIB Domain
      </Button>

      <Table
        columns={columns}
        dataSource={sibDomains || []}
        pagination={false}
        rowKey="id"
      />

      {visible && (
        <SIBDomainForm
          domainInfo={selectedDomain}
          visible={visible}
          onHideForm={() => {
            setSelectedDomain(null);
            setVisible(false);
          }}
        />
      )}
    </Spin>
  );
}
